import { useForm } from "react-hook-form";
import { Generico } from "../../components/Generico";
import { Etiqueta } from "../../models/administracion/Etiqueta";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { useEffect, useState } from "react";
import { InputComponent } from "../../components/InputComponent";
import { confirmDialog } from "primereact/confirmdialog";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { Dialog } from "primereact/dialog";

export const EtiquetaUsuario = ({ menu, usuario, empresa, permss, generic, toast, opcion = 'menu', lista }) => {

    const omodel = new Etiqueta();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue } = useForm({ defaultValues, shouldTrim: true });
    const etiquetaSrv = new MonitoreoService();
    const [registros, setRegistros] = useState(null);
    const [dialogEtiqueta, setDialogEtiqueta] = useState(false);
    const [item, setItem] = useState(null);
    const [load, setLoad] = useState(false);
    const { table, setLoading, setTotalRecords, lazyParams, inText, inDrop } =
        InputComponent({ registers: registros, omodel, generic, errors, control, permss, id: getValues('id') });

    useEffect(() => {
        loadLazy();
    }, [menu]);

    const editar = () => {
        etiquetaSrv.consultar(`${item?.id}/${menu}`, 'admin-etiqueta-usuario/consulta').then(res => {
            const listado = {};
            if (opcion !== 'menu') {
                listado.tipo_negocio = lista;
            }
            const _etiqueta = res.data;

            Object.keys(listado).forEach(function (key) {
                if (_etiqueta[key] != null) {
                    listado[key].forEach(element => {
                        if (element.cat_id === _etiqueta[key]) {
                            _etiqueta[key] = element;
                        }
                    });
                }
            });
            reset(generic.renewValues(_etiqueta, omodel.model));
            setDialogEtiqueta(true);
        });
    }

    const loadLazy = () => {
        setLoading(true);

        let _lazyParams = lazyParams;
        _lazyParams.idp = menu;
        _lazyParams.opcion = opcion;
        _lazyParams.empresa = empresa;
        _lazyParams.usuario = usuario;
        etiquetaSrv.listado('admin-etiqueta-usuario/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegistros(res.data.registros);
            setLoading(false);
        });
    }

    const onSubmit = (data) => {
        data.idp = menu;
        data.opcion = opcion;
        data.usuario = usuario;
        data.empresa = empresa;
        setLoad(true);
        if (getValues('id') == null) {
            etiquetaSrv.nuevo(data, 'admin-etiqueta-usuario/nuevo').then(res => {
                setLoad(false);
                setDialogEtiqueta(false);
                loadLazy();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                setLoad(false);
                generic.funcError(error, toast, setError);
            });
        }
        else {
            etiquetaSrv.editar(data, 'admin-etiqueta-usuario/editar').then(res => {
                setDialogEtiqueta(false);
                loadLazy();
                setLoad(false);
                generic.funcSuccess(res, toast);
            }).catch(error => {
                setLoad(false);
                generic.funcError(error, toast, setError);
            });
        }
    }

    const openNew = () => {
        setItem(null);
        setDialogEtiqueta(true);
        reset(defaultValues);
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la información?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteItem()
        });
    };

    const deleteItem = () => {
        etiquetaSrv.eliminar(`${item?.id}/${menu}`, 'admin-etiqueta-usuario/eliminar').then(res => {
            loadLazy();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const onError = (errors) => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const clonar = () => {
        reset(defaultValues);
        setValue('origen', item?.id);
        setValue('sigla', item?.sigla);
        setValue('etiqueta', item?.etiqueta);
        setDialogEtiqueta(true);
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar && ((opcion === 'menu' && item?.origen == null) || (['empresa', 'usuario'].includes(opcion) && item?.origen !== null)))
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editar() } });
        if (permss?.actualizar && ['empresa', 'usuario'].includes(opcion) && item?.origen == null)
            items.push({ label: 'Generar a partir', icon: 'pi pi-clone', command: () => { clonar() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });

        return [{ label: 'Opciones', items: items }];
    }

    const headerTemplate = (options) => {
        return (
            <div className={options.className}>
                <div className="flex align-items-center gap-2">
                    {permss?.crear && opcion === 'menu' && <Button icon="pi pi-plus" className="p-button-rounded p-button-success mr-2" type="button" onClick={openNew} />}
                    <span className="font-bold">Etiquetas</span>
                </div>
            </div>
        );
    }

    return (
        <>
            <br />
            <Panel headerTemplate={headerTemplate}>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Panel>

            <Dialog visible={dialogEtiqueta} header={getValues('id') == null ? "Nueva Información" : "Editar Información"} modal className="p-fluid modal-ssize"
                onHide={e => setDialogEtiqueta(false)} style={{ width: '400px' }}>
                <br />
                <form onSubmit={handleSubmit(onSubmit, onError)}>
                    <div className="formgrid grid">
                        {inText('etiqueta', {}, 12)}
                        {inText('sigla', opcion === 'menu' ? {} : { readOnly: true }, 12)}
                        {opcion !== 'menu' && inDrop('tipo_negocio', lista, { lab: omodel.optionLabel }, 12)}
                    </div>

                    {generic.buttonsForms(setDialogEtiqueta, load)}
                </form>
            </Dialog>
        </>
    )
}
